import { Button, Typography } from "@mui/material";

export const docsColumns = (from) => [
  {
    accessorKey: "docNum",
    header: "Doc #",
    size: 150, // Reduced width
  },
  { accessorKey: "description", header: "Description", size: 250 },
  {
    accessorKey: "revNum",
    header: "Rev #",
    size: 100, // Reduced width
  },
  {
    accessorKey: "docLink",
    header: "Document Link",
    size: 80, // Reduced width
    muiTableHeadCellProps: {
      align: "center", // ✅ header
    },
    muiTableBodyCellProps: {
      align: "center", // ✅ body
    },
    Cell: ({ cell }) => (
      <a href={cell.getValue()} target="_blank" rel="noopener noreferrer">
        Link
      </a>
    ),
  },
  {
    accessorKey: "comment",
    header: "Add Comment",
    size: 180,
    muiTableHeadCellProps: {
      align: "center", // ✅ header
    },
    muiTableBodyCellProps: {
      align: "center", // ✅ body
    },
    Cell: ({ row }) => {
      const comment = row.original.comment;

      if (!comment) {
        return from === "portal" ? (
          <Button
            size="small"
            variant="outlined"
            onClick={() => {
              console.log("Add comment for row:", row.original.id);
              // open comment modal here
            }}
          >
            Add Comment
          </Button>
        ) : (
          <Typography variant="body2" sx={{ color: "#777" }}>
            No Comment yet
          </Typography>
        );
      }

      return (
        <Typography variant="body2" noWrap>
          {comment}
        </Typography>
      );
    },
  },
  {
    accessorKey: "revisedFile",
    header: "Upload Revised File",
    size: 120,
    muiTableHeadCellProps: {
      align: "center", // ✅ header
    },
    muiTableBodyCellProps: {
      align: "center", // ✅ body
    },
    Cell: ({ row }) => {
      const file = row.original.revisedFile;

      if (!file) {
        return from === "portal" ? (
          <Button size="small" variant="outlined" component="label">
            Upload
            <input
              hidden
              type="file"
              onChange={(e) => {
                const selectedFile = e.target.files?.[0];
                if (!selectedFile) return;

                console.log("Upload revised file for row:", row.original.id);
              }}
            />
          </Button>
        ) : (
          <Typography variant="body2" sx={{ color: "#777" }}>
            Not revised yet
          </Typography>
        );
      }

      return (
        <Button
          size="small"
          variant="contained"
          onClick={() => {
            window.open(file.url, "_blank");
          }}
        >
          Download
        </Button>
      );
    },
  },
];
